import React, { useState } from "react";
import TodaysSpecialPoster from "../shared/TodaysSpecialPoster.jsx";

// Public page for bartenders and cooks: portal.barfunfinder.com/staff-post
// No account needed, just the bar's staff code (from the owner's Bar
// Profile page). The code is remembered on this phone so they only type
// it once. The code is checked on the server when they post.

const CODE_KEY = "bff_staff_code";

function readSavedCode() {
  try {
    return window.localStorage.getItem(CODE_KEY) || "";
  } catch {
    return "";
  }
}

function saveCode(code) {
  try {
    if (code) window.localStorage.setItem(CODE_KEY, code);
    else window.localStorage.removeItem(CODE_KEY);
  } catch {
    // Private browsing etc. They'll just retype it next time.
  }
}

export default function StaffPost() {
  const [code, setCode] = useState(readSavedCode());

  const updateCode = (value) => {
    const clean = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
    setCode(clean);
    saveCode(clean);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#0B0B12", color: "#fff", fontFamily: "Inter, sans-serif" }}>
      <div style={{ maxWidth: "480px", margin: "0 auto", padding: "24px 16px 40px" }}>
        <h1 style={{ fontSize: "28px", margin: "0 0 4px" }}>Bar Fun Finder</h1>
        <p style={{ color: "#B8B0C8", fontSize: "16px", margin: "0 0 20px" }}>Staff posting</p>

        <label style={{ display: "block", fontSize: "16px", marginBottom: "6px" }}>Staff code</label>
        <input
          type="text"
          value={code}
          onChange={(e) => updateCode(e.target.value)}
          placeholder="Ask your manager"
          autoCapitalize="characters"
          autoComplete="off"
          style={{
            width: "100%", boxSizing: "border-box", padding: "14px", fontSize: "22px",
            letterSpacing: "3px", fontFamily: "monospace", textAlign: "center",
            borderRadius: "10px", border: "1px solid rgba(255,255,255,0.15)",
            background: "#16121F", color: "#fff", marginBottom: "20px",
          }}
        />

        <TodaysSpecialPoster
          kind="food"
          disabled={code.length < 4}
          getAuthBody={async () => ({ staffCode: code })}
          getAuthHeaders={async () => ({})}
        />

        <div style={{ height: "20px" }} />

        <TodaysSpecialPoster
          kind="pulltabs"
          disabled={code.length < 4}
          getAuthBody={async () => ({ staffCode: code })}
          getAuthHeaders={async () => ({})}
        />
      </div>
    </div>
  );
}
